export const APP_ROOT_ID = 'add-to-wishlist-component-root';

export const GENERIC_ERROR_MESSAGE = 'Sorry there appears to be a problem with Wish List, please try again later.';

export const SELECT_SIZE_ERROR_MESSAGE = 'Please choose an option above first.';

export const LIST_FULL_ERROR_MESSAGE = 'Your wish list is full.';

export const WISH_LIST_QUERY_STRING = 'wishlist=interacted';

export const MONETATE_ITEM_ADDED_KEY = 'add_to_wish_list_button_item_added';

export const MONETATE_ITEM_ADDED_FROM_PLP_KEY = 'plp_wishlist_heart_icon_click_success';

export const MONETATE_ITEM_ADDED_FROM_PDP_KEY = 'pdp_wishlist_add_success';

export const MONETATE_ITEM_ADDED_FROM_OOS_PDP_KEY = 'pdp_wishlist_add_success_oos';

export const MONETATE_ITEM_ADDED_FROM_BASKET_KEY = 'basket_wishlist_add_success';

export const MONETATE_ITEM_ADDED_FROM_RECS_KEY = 'recs_wishlist_add_success';

export const MONETATE_ITEM_ADDED_FROM_RECS_ERROR_KEY = 'recs_wishlist_add_error';

export const MONETATE_ITEM_REMOVED_FROM_RECS_KEY = 'recs_wishlist_remove_success';

export const MONETATE_ITEM_REMOVED_FROM_RECS_ERROR_KEY = 'recs_wishlist_remove_error';

export const MONETATE_ITEM_ADDED_FROM_GUEST_PDP_KEY = 'pdp_guest_wishlist_add_success';

export const MONETATE_ITEM_ADDED_FROM_GUEST_PLP_KEY = 'plp_guest_wishlist_add_success';

export const WL_PRODUCT_QUERY_STRING = 'wlpid';

export const WISHLIST_CONFIRMATION_LINK_CLICK_EVENT_KEY = 'wishlist_confirmation_link_click';

export const WISHLIST_PDP_CLICK_EVENT_KEY = 'wishlist_pdp_click';

export const WISHLIST_PDP_SIZE_ERROR = 'wishlist_pdp_size_error';

export const EMAIL_ME_CLICK = 'wishlist_email_me_click';
